import _ from "lodash";

export default function SuggestionBox({ heading }: { heading: string }) {
  return (
    <p className={`text-xxs1 placeholderLoader text-gray-400 font-medium`}>
      {heading}
    </p>
  );
}
